// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartsBlock__f9vs8 {
  grid-area: 2/1/2/3;
  height: 100%;
  padding: 1px;
  margin-bottom: 25px;
}

.chartsBlockWrapper__EtWKW {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 7px;
}

.blockHead__kEYNM {
  min-height: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.blockTitle__N8eDT {
  font-size: 11px;
  line-height: 14px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
  min-height: 16px;
}

.chartsBlockLink__UO99E {
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: var(--buttons-text-secondary);
  text-transform: uppercase;
  text-decoration: none;
}

.blockContainer__WTmeI {
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.chartsHead__xI1yx {
  height: 85px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px;
  background-color: var(--tables-secondary-row-sub-title-surface);
  border: 1px solid var(--tables-secondary-row-sub-title-surface);
}

.chartsActions__sV_Rx {
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.downloadIcon__NT5wk {
  width: 24px;
  height: 24px;
  cursor: pointer;
  outline: none;
}
.downloadIcon__NT5wk path {
  stroke: var(--buttons-surface);
}

.fullscreenIcon__qzY9i {
  width: 24px;
  height: 24px;
  cursor: pointer;
  outline: none;
}
.fullscreenIcon__qzY9i path {
  fill: var(--buttons-surface);
}

@media print {
  @page {
    size: 50mm 150mm;
    margin: 0.5cm;
    padding: 0.5cm;
  }
  .onPrintHead {
    overflow: hidden;
    height: 0;
    display: none;
  }
}
.skeletonWrapper__oSueU {
  min-height: 84px;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}

.skeletonText__CZf5u {
  width: 100%;
  height: 39px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorDetails/components/SensorCharts/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,oCAAA;EACA,yBAAA;EACA,qBAAA;AAzEF;;AA4EA;EACE,2DAAA;EACA,wCAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,+DAAA;EACA,+DAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AAzEF;AA2EE;EACE,8BAAA;AAzEJ;;AA6EA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;AA1EF;AA4EE;EACE,4BAAA;AA1EJ;;AA8EA;EACE;IACE,gBAAA;IACA,aAAA;IACA,cAAA;EA3EF;EA+EE;IACE,gBAAA;IACA,SAAA;IACA,aAAA;EA7EJ;AACF;AAiFA;EACE,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yDAAA;AA/EF;;AAkFA;EACE,WAAA;EACA,YAAA;AA/EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.chartsBlock {\n  grid-area: 2/1/2/3;\n  height: 100%;\n  padding: 1px;\n  margin-bottom: 25px;\n}\n\n.chartsBlockWrapper {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 7px;\n}\n\n.blockHead {\n  min-height: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.blockTitle {\n  font-size: 11px;\n  line-height: 14px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n  min-height: 16px;\n}\n\n.chartsBlockLink {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 14px;\n  color: var(--buttons-text-secondary);\n  text-transform: uppercase;\n  text-decoration: none;\n}\n\n.blockContainer {\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.chartsHead {\n  height: 85px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 25px;\n  background-color: var(--tables-secondary-row-sub-title-surface);\n  border: 1px solid var(--tables-secondary-row-sub-title-surface);\n}\n\n.chartsActions {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n}\n\n.downloadIcon {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  outline: none;\n\n  path {\n    stroke: var(--buttons-surface);\n  }\n}\n\n.fullscreenIcon {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  outline: none;\n\n  path {\n    fill: var(--buttons-surface);\n  }\n}\n\n@media print {\n  @page {\n    size: 50mm 150mm;\n    margin: 0.5cm;\n    padding: 0.5cm;\n  }\n\n  :global {\n    .onPrintHead {\n      overflow: hidden;\n      height: 0;\n      display: none;\n    }\n  }\n}\n\n.skeletonWrapper {\n  min-height: 84px;\n  padding: 15px 25px;\n  display: flex;\n  align-items: center;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n}\n\n.skeletonText {\n  width: 100%;\n  height: 39px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartsBlock": `chartsBlock__f9vs8`,
	"chartsBlockWrapper": `chartsBlockWrapper__EtWKW`,
	"blockHead": `blockHead__kEYNM`,
	"blockTitle": `blockTitle__N8eDT`,
	"chartsBlockLink": `chartsBlockLink__UO99E`,
	"blockContainer": `blockContainer__WTmeI`,
	"chartsHead": `chartsHead__xI1yx`,
	"chartsActions": `chartsActions__sV_Rx`,
	"downloadIcon": `downloadIcon__NT5wk`,
	"fullscreenIcon": `fullscreenIcon__qzY9i`,
	"skeletonWrapper": `skeletonWrapper__oSueU`,
	"skeletonText": `skeletonText__CZf5u`
};
module.exports = ___CSS_LOADER_EXPORT___;
